// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6r-0";
export var startPickingButton = "_6r-1";